import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { hide, onHide, onShow, show, update } from '@intercom/messenger-js-sdk';


// Jelenleg ha false-al kellene inicializálni a chatet akkor nem működik
// valahogy detektálni kellene, hogy mikor tölt be az intercom, de nem provideolnak eventet, mint a Tidio

@Injectable({
  providedIn: 'root'
})
export class TidioChatService implements OnDestroy {
  private isTidioChatVisible: boolean = true;

  constructor() {
  }

  async init() {
    const { default: Intercom } = await import('@intercom/messenger-js-sdk');
    Intercom({
      app_id: 'kw980vpn',
      language_override: 'hu',
      hide_default_launcher: !this.isTidioChatVisible
    })
  }


  ngOnDestroy(): void {

  }

  readonly onLoadedTidioChat = () => {
    if (this.isTidioChatVisible == false) {
      this.hideChat();
    }
  }

  public showChat() {
    update({ hide_default_launcher: false })
    this.isTidioChatVisible = true;
  }

  public hideChat() {
    update({ hide_default_launcher: true })
    this.isTidioChatVisible = false;
  }
}
